/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import PropTypes from 'prop-types';
import { Image } from 'antd';

const DocumentsHeader = ({logoAppSrc, title}) => {
    return (
        <div className="legal-docs-header">
            {logoAppSrc && (
                <div className="legal-docs-header__logo">
                    <Image width={120} src={logoAppSrc} preview={false}/>
                    <div className="legal-docs-header__reg">&reg;</div>
                </div>
            )}
            {title && (
                <div className={`legal-docs-header__content ${!logoAppSrc ? 'legal-docs-header__content--full':''}`}>
                    <div className="base-title">{title}</div>
                </div>
            )}
        </div>
    );
};

DocumentsHeader.propTypes = {
    logoAppSrc: PropTypes.string,
    title: PropTypes.string,
};

DocumentsHeader.defultProps = {
    logoAppSrc: '',
    title: '',
};

export default DocumentsHeader;
